<template>
  <Teleport to="body">
    <Transition name="expired-modal">
      <div
        v-if="show"
        class="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
        role="dialog"
        aria-modal="true"
        aria-labelledby="plan-expired-title"
      >
        <div class="relative w-full max-w-md overflow-hidden rounded-2xl border border-light-border dark:border-dark-border bg-light-background dark:bg-dark-background shadow-2xl">
          <div class="px-6 pt-8 pb-6 text-center">
            <div class="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
              <ExclamationTriangleIcon class="h-7 w-7 text-amber-500 dark:text-amber-400" />
            </div>
            <h2 id="plan-expired-title" class="mt-4 text-xl font-bold text-light-text-primary dark:text-dark-text-primary">
              Tu plan venció
            </h2>
            <p class="mt-2 text-sm text-light-text-secondary dark:text-dark-text-secondary leading-relaxed">
              {{ message || 'Algunas funciones premium quedaron bloqueadas. Tus datos están a salvo: renová tu plan para volver a usarlas.' }}
            </p>
          </div>

          <div class="px-6 pb-6 space-y-2.5">
            <button
              type="button"
              class="w-full rounded-xl bg-light-accent dark:bg-dark-accent px-4 py-3 text-sm font-semibold text-light-cta-text dark:text-dark-cta-text hover:opacity-90 transition"
              @click="emit('renew')"
            >
              Renovar mi plan
            </button>
            <button
              type="button"
              class="w-full rounded-xl border border-light-border dark:border-dark-border px-4 py-3 text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary hover:bg-light-border/30 dark:hover:bg-dark-border/30 transition"
              @click="emit('continue-free')"
            >
              Seguir con el plan gratuito
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'

defineProps({
  show: { type: Boolean, default: false },
  message: { type: String, default: '' }
})

const emit = defineEmits(['renew', 'continue-free'])
</script>

<style scoped>
.expired-modal-enter-active,
.expired-modal-leave-active {
  transition: opacity 0.2s ease;
}
.expired-modal-enter-from,
.expired-modal-leave-to {
  opacity: 0;
}
.expired-modal-enter-active > div,
.expired-modal-leave-active > div {
  transition: transform 0.25s ease;
}
.expired-modal-enter-from > div,
.expired-modal-leave-to > div {
  transform: scale(0.95) translateY(10px);
}
</style>
